export const image = {
  link: "https://res.cloudinary.com/df3ajcohw/image/upload/v1786938540/assets/ihyfoszoypdaz329ystz.jpg",
  alt: "TraStar Headquarters",
};
